import { supportedLocalesMetadata } from '../consts/supported-locales-metadata.map';
export function getSupportedLocaleMetadata(locale) {
    return supportedLocalesMetadata[locale];
}
